import { createReducer } from '@reduxjs/toolkit';
import { initializeMultiUserClient, pollMultiUserEvent, receiveMultiUserEvent } from './actions';
import { MultiUserState } from './types';

const initialState: MultiUserState = {
  clients: {},
  latestCursor: null,
  latestLongPollId: null,
  options: null,
};

const multiUserReducer = createReducer(initialState, (builder) => {
  builder.addCase(initializeMultiUserClient, (state, action) => {
    state.options = action.payload;
  });
  builder.addCase(pollMultiUserEvent.pending, (state, action) => {
    state.latestLongPollId = action.meta.requestId;
  });
  builder.addCase(receiveMultiUserEvent, (state, action) => {
    const response = action.payload;
    const { cursor, state: clients } = response;
    state.latestCursor = cursor;
    state.clients = clients;
  });
});

export default multiUserReducer;
